var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.9435 11.332C36.6635 11.332 11.3335 36.7187 11.3335 67.9987C11.3335 99.2787 36.6635 124.665 67.9435 124.665C99.2802 124.665 124.667 99.2787 124.667 67.9987C124.667 36.7187 99.2802 11.332 67.9435 11.332ZM68.0002 113.332C42.9535 113.332 22.6668 93.0454 22.6668 67.9987C22.6668 42.952 42.9535 22.6654 68.0002 22.6654C93.0468 22.6654 113.334 42.952 113.334 67.9987C113.334 93.0454 93.0468 113.332 68.0002 113.332ZM66.7535 39.6654H66.4135C64.1468 39.6654 62.3335 41.4787 62.3335 43.7454V70.492C62.3335 72.4754 63.3535 74.3454 65.1102 75.3654L88.6268 89.4754C90.5535 90.6087 93.0468 90.042 94.1802 88.1154C94.4647 87.6565 94.654 87.1451 94.7368 86.6116C94.8195 86.0781 94.794 85.5333 94.6618 85.0099C94.5297 84.4864 94.2934 83.9949 93.9673 83.5646C93.6412 83.1343 93.2318 82.7741 92.7635 82.5054L70.8335 69.472V43.7454C70.8335 41.4787 69.0202 39.6654 66.7535 39.6654Z",
    fill: "#84E1CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.102acd5654cd8542152f7dab02510096.svg";
export { ForwardRef as ReactComponent };